<template>
  <div class="upload-file-box">
    <label
      class="upload-file-label"
      :for="comId"
    >
      <input
        :id="comId"
        type="file"
        :accept="accept"
        @change="handleFileChange"
      >
      {{ $t('component.upload') }}
    </label>
    <div
      class="upload-file-preview"
      v-if="fileList.length"
    >
      <div
        class="preview"
        v-for="(file, index) in fileList"
        :key="file.uid"
      >
        <img
          v-if="isImage(file)"
          class="pic"
          :src="file.thumbUrl | checkUrl"
          alt="uploadFile"
        >
        {{ file.name }}
        <svg
          class="icon icon-error"
          @click="handleDelete(index)"
        >
          <use xlink:href="#icon-error" />
        </svg>
      </div>
    </div>
  </div>
</template>
<script>
  import COS from 'cos-js-sdk-v5'
  import TencentCloudApi from '@api/sdk/tencentCloud'

  const getUid = () => `uploadFile_${Math.random()}_${Date.now()}`
  const getName = name => {
    return name.replace(/([^.]+)(?=.([^.]+)$)/,`${Math.random().toString(36).substr(2)}_${Date.now()}_$1`)
  }

  export default {
    name: 'UploadFile',
    props: {
      value: {
        type: Array,
        default: () => []
      },
      accept: {
        type: String,
        default: ''
      },
      multiple: {
        type: Boolean,
        default: false
      },
      maxByte: {
        type: Number,
        default: null
      },
      maxCount: {
        type: [Number],
        default: Number.MAX_VALUE
      },
      onBefore: {
        type: [Function],
        default: () => true
      }
    },
    data () {
      return {
        comId: getUid(),
        fileId: Date.now(),
        fileBlod: null,
        fileList: [],
      }
    },
    beforeCreate () {
      this.cos = new COS({
        getAuthorization(options, callback) {
          TencentCloudApi.fetchTencentCloudAuth({
            method: (options.Method || 'get').toLowerCase(),
            pathname: '/' + (options.Key || '')
          }).then(data => {
            callback(data.auth)
          })
        }
      })
    },
    watch: {
      value: {
        handler (val) {
          this.fileList = val
        },
        immediate: true
      },
      fileList (value) {
        this.$emit('input', value)
        this.$emit('onChange', value)
      }
    },
    filters: {
      checkUrl (val) {
        const isUrlWithProtocol = /^(https?:|\/\/)/.test(val)
        return isUrlWithProtocol ? val : `//${val}`
      }
    },
    methods: {
      handleFileChange (event) {
        const target = event.target
        const fileBlod = target.files[0]
        this.fileBlod = Object.freeze(fileBlod)
        target.value = ''
        if (this.maxByte && fileBlod.size > this.maxByte) {
          this.$message.error('文件大小不能超过 ' + (this.maxByte / 1024 / 1024) + 'M')
          return
        }
        this.onBefore() ? this.handleUploadStart() : this.handleUploadError()
      },
      handleUploadError () {
        this.fileBlod = {}
        this.$emit('on-error')
      },
      handleUploadStart () {
        this.cos.putObject({
          Bucket: 'mini-1251352189',
          Region: 'ap-guangzhou',
          Key: getName(this.fileBlod.name),
          Body: this.fileBlod,
        }, (err, res) => {
          if(err) {
            throw new Error(err.Message)
          }
          if (res.statusCode !== 200) return
          const hasProtocolWithUrl = /http/.test(res.Location)
          const location = hasProtocolWithUrl ? res.Location : `//${res.Location}`
          const file = {
            uid: this.fileId++,
            name: this.fileBlod.name,
            type: this.fileBlod.type,
            status: 'done',
            url: location,
            thumbUrl: location,
          }
          this.fileList = this.multiple ? [...this.fileList, file] : [file]
        })
      },
      handleDelete (index) {
        this.fileList.splice(index, 1)
      },
      isImage (file) {
        return (file.type && file.type.startsWith('image/')) || /\.(jpe?g|png|gif|webp|bmp|svg)$/i.test(file.name)
      },
    }
  }
</script>
<style lang="scss" scoped>
  .upload-file-box{
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }
  .upload-file-label{
    display: inline-block;
    height: 34px;
    padding: 0 23px;
    box-sizing: border-box;
    color: #fff;
    border-radius: 4px;
    background-color: #0884f3;
    cursor: pointer;
    input{
      display: none;
    }
  }
  .upload-file-preview{
    display: flex;
    flex-direction: column;
    width: 100%;
    margin-top: 0.4em;
    .preview{
      position: relative;
      display: flex;
      flex: 1;
      align-items: center;
      height: 60px;
      padding: 5px;
      border-radius: 4px;
      border: 1px solid #ddd;
      background: #fff;
      cursor: pointer;
      &:nth-child(n+2){
        margin-top: 1em;
      }
      &:hover{
        .icon-error{
          opacity: 1;
        }
      }
    }
    .pic{
      width: 50px; 
      height: auto;
      max-height: 50px;
      margin-right: 1em;
    }
    .icon-error{
      position: absolute;
      top: 0;
      right: 0;
      padding: 10px;
      width: 15px;
      height: 15px;
      opacity: 0;
      transition: all .3s;
      transform: translate(50%, -50%);
    }
  }
</style>


